import React from 'react';
import { Line } from 'react-chartjs-2';
import { Bar } from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  CategoryScale,
  Tooltip,
  Legend,
  Filler,
  Title,
  BarElement,
} from 'chart.js';

ChartJS.register(
  LinearScale,
  LineElement,
  CategoryScale,
  PointElement,
  Tooltip,
  Legend,
  Filler,
  zoomPlugin,
  Title,
  BarElement
);
const LineChart = (props) => {
  const { type, data, options, ...rest } = props;

  let CType = type;
  return CType === 'bar' ? (
    <Bar data={data} options={options} {...rest} />
  ) : CType === 'line' ? (
    <Line data={data} options={options} {...rest} />
  ) : (
    ''
  );
};

export default LineChart;
